<template>
    <div id="snackbar">
        <span>{{ message }}</span>
    </div>
</template>

<script lang="ts">
/* eslint-disable no-undef */
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { EventBus } from '@/utils/eventbus';

@Component({
    name: 'snackbar'
})

export default class Snackbar extends Vue {

    private message = '';
    private snackbarClass = '';
    private isOpen = false;

    constructor () {
        super();
        this.attachListener();
    }

    private beforeDestroy(): void {
        EventBus.$off(EventBus.GLOBAL.SHOW_SNACKBAR, this.handleShowSnackbar);
    }

    private attachListener(): void {
        EventBus.$on(EventBus.GLOBAL.SHOW_SNACKBAR, this.handleShowSnackbar);
    }

    private handleShowSnackbar(data: any): void {
        if (!this.isOpen) {
            const el = $('#snackbar');
            this.snackbarClass = data.class !== undefined ? data.class : '';

            if (data.message !== undefined) {
                if (data.translate !== undefined && data.translate === true) {
                    const translated = this.$t(data.message);
                    this.message = translated.toString();
                } else {
                    this.message = data.message;
                }
            } else {
                this.message = '';
            }

            let duration = 3000;
            if (data.duration) {
                duration = data.duration;
            }

            this.isOpen = true;
            el.addClass('open ' + this.snackbarClass);
            el.addClass(this.snackbarClass);
            setTimeout(() => {
                el.removeClass('open ' + this.snackbarClass);
                el.removeClass('open');
                this.isOpen = false;
            }, duration);
        }
    }
}
</script>


<style lang="less" >
#snackbar {
    text-align: center;
    padding: 10px 20px;
    background: #333;
    color: #fff;
    font-size: 18px;
    position: fixed;
    bottom: 30px;
    max-height: 50px;
    left: 10px;
    border-radius: 3px;
    min-width: 300px;
    box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);
    z-index: 1110;
    span {
        vertical-align: middle;
    }
    opacity: 0;
    transform: translate(9999px);
}
#snackbar.open {
    opacity: 1;
    transform: translate(0);
    transition: opacity 0.2s linear;
    &.error {
        background: #f44336;
        border: 1px solid #e33225;
    }
    &.info {
        background: #2196F3;
        border: 1px solid #1E88E5;
    }
    &.success {
        background: #4CAF50;
        border: 1px solid #43A047;
    }
    &.warning {
        background-color: #f0ad4e;
        border: 1px solid #eea236;
    }
}
</style>
